<template>
  <div v-loading="loading">
    <form-box :title="$t('school.info')">
      <template slot="right">
        <el-button
          v-if="application && application.cert"
          type="primary"
          plain
          @click="
            $router.push(
              `/school-record/${serviceType}/${application.cert.coachId}`
            )
          "
        >
          {{ $t("school.record") }}
        </el-button>
      </template>
      <div v-if="application && application.cert" class="itnal_info_box">
        <el-row :gutter="86">
          <!-- 商業登記類型 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">
              {{ $t("school.companyIdentityType") }}:
            </div>
            <div class="itnal_info_data">
              {{ application.cert.companyIdentityType | idType }}
            </div>
          </el-col>
          <!-- 商業登記編號 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">{{ $t("school.companyBrNo") }}:</div>
            <div class="itnal_info_data">
              {{ application.cert.companyBrNo }}
            </div>
          </el-col>
          <!-- 學校執照編號 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">{{ $t("school.licenseNo") }}:</div>
            <div class="itnal_info_data">
              {{ application.cert.licenseNo }}
            </div>
          </el-col>
          <!-- 駕駛學校執照最後簽發日期 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">
              {{ $t("school.lastIssueDate") }}:
            </div>
            <div class="itnal_info_data">
              {{ application.cert.lastIssueDate | formatDT("dd/MM/yyyy") }}
            </div>
          </el-col>
          <!-- 駕駛學校 -->
          <el-col :xs="24" :sm="24">
            <div class="itnal_info_label">{{ $t("school.schoolName") }}:</div>
            <div class="itnal_info_data">
              <div
                v-if="
                  !application.cert.schoolNameCn &&
                  !application.cert.schoolNameEn
                "
              >
                --
              </div>
              <div v-else>
                <div>{{ application.cert.schoolNameCn }}</div>
                <div>{{ application.cert.schoolNameEn }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="infoTips">
          {{ $t("message.DataRegistration.International.infoTips") }}
        </div>
      </div>
      <el-form
        :model="application"
        class="form_type1_box"
        hide-required-asterisk
      >
        <el-row :gutter="86">
          <!-- 聯絡電話 -->
          <el-col :xs="24" :sm="24">
            <el-form-item :label="$t('school.mobile_sms')">
              <el-row :gutter="86" style="width: 100%">
                <el-col :xs="24" :sm="12">
                  <el-input
                    v-model="application.macauMobile"
                    placeholder=""
                    disabled
                  ></el-input>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </form-box>
    <div class="next_btn" v-if="application && application.spCode == '00'">
      <GradientBtn @click="pay()" :loading="submitLoading"
        >{{ $t("school.payment_btn") }} MOP
        {{ application.cheque.totalAmount }}
      </GradientBtn>
    </div>
    <form-box v-if="vssData.spCode == '00'" :title="$t('school.payment_info')">
      <!-- 表單 -->
      <el-form
        v-if="vssData && vssData.spCode == '00'"
        ref="ruleForm"
        label-position="top"
        :model="application"
        class="form_type1_box"
        hide-required-asterisk
        :rules="ruleForm"
      >
        <!-- 缴费信息 -->
        <el-row :gutter="86">
          <!-- 繳付項目描述 -->
          <el-col :xs="24" :sm="24">
            <el-row :gutter="86">
              <el-col :xs="24" :sm="24">
                <el-form-item :label="$t('school.payment_name')">
                  <el-input
                    v-if="$i18n.locale === 'PT'"
                    type="textarea"
                    autosize
                    v-model="application.cheque.namePt"
                    disabled
                  ></el-input>
                  <el-input
                    v-else
                    type="textarea"
                    autosize
                    v-model="application.cheque.nameCn"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <!-- 年度費用 -->
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('school.amount')">
              <el-input v-model="application.cheque.amount" disabled></el-input>
            </el-form-item>
          </el-col>
          <!-- 印花稅（申請費用的 10%） -->
          <el-col :xs="24" :sm="12">
            <el-form-item :label="$t('school.taxAmount')">
              <el-input
                v-model="application.cheque.taxAmount"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 繳付方式 -->
          <el-col :xs="24" :sm="24">
            <el-form-item
              :label="$t('message.DataRegistration.Taxi.payment')"
              prop="paymentType"
            >
              <div>
                <el-radio
                  v-for="(item, i) in payMethod.filter(
                    (ele) =>
                      ele.paymentChannel !== 'MPAY' ||
                      (vssData.application &&
                        vssData.application.cheque &&
                        vssData.application.cheque.totalAmount <= 20000)
                  )"
                  :key="i"
                  v-model="application.paymentType"
                  :label="item.paymentChannel"
                >
                  <img
                    class="mpay_icon"
                    :src="require(`@/assets/${item.icon}.png`)"
                    alt=""
                  />
                </el-radio>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24">
            <div class="payment_notice">
              <div class="pn_title">
                {{ $t("school.notice") }}
                <span
                  style="color: #ee7a34; font-size: 20px; font-weight: bold"
                >
                  {{ $t("school.payment_notice") }}
                </span>
              </div>
              <ul class="pn_list">
                <li>
                  <span class="pn_email_text">{{
                    application && application.paymentType === "CEP"
                      ? $t("school.email_required")
                      : $t("school.email")
                  }}</span>
                  <!-- 電子郵件 -->
                  <el-form-item label="" prop="email">
                    <el-input
                      v-model="application.email"
                      :placeholder="$t('school.email_plh')"
                    ></el-input>
                  </el-form-item>
                  <!-- 電子郵件確認 -->
                  <el-form-item label="" prop="confirmEmail">
                    <el-input
                      v-model="application.confirmEmail"
                      :placeholder="$t('school.email_again_plh')"
                    ></el-input>
                  </el-form-item>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </form-box>
    <!-- spCode信息 -->
    <msg-box
      v-if="vssData.spCode"
      :code="vssData.spCode"
      :normalCode="['00']"
      :successCodes="['D27']"
      :spResult="vssData[`spResult${$t('message.lans')}`]"
    ></msg-box>
    <div class="next_btn">
      <GradientBtn
        v-if="vssData && vssData.spCode == '00'"
        @click="submit"
        :loading="submitLoading"
        >{{ $t("school.payment_btn") }}
        {{ application.cheque.totalAmount }}
      </GradientBtn>
    </div>
    <!-- 重複支付彈窗 -->
    <ComputetTimeDialog
      :show="showRepeatDialog"
      :timeParams="timeParams"
      @close="handleClose"
    ></ComputetTimeDialog>
  </div>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import { resourcePath } from "@/api/axios";
import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";
import FormBox from "../components/FormBox.vue";
import GradientBtn from "@/components/GradientBtn.vue";
import { formatAmount } from "@/filters";
import ComputetTimeDialog from "@/components/ComputetTimeDialog.vue";
import MsgBox from "@/components/MsgBox.vue";
import SchoolRenewApplicationAPI from "@/api/SchoolRenewApplicationAPI";
import SchoolRenewApplicationPublicAPI from "@/api/SchoolRenewApplicationPublicAPI";
export default {
  components: { FormBox, GradientBtn, ComputetTimeDialog, MsgBox },
  filters: {
    idType(val) {
      if (!val) return "";
      switch (val) {
        case "CO":
          return i18n.t("school.CO");
        case "EM":
          return i18n.t("school.EM");
        case "SO":
          return i18n.t("school.SO");
        case "ES":
          return this.t("school.ES");
        default:
          return val;
      }
    },
  },
  data() {
    let emailCheck = (rule, value, callback) => {
      if (
        this.application &&
        this.application.paymentType === "CEP" &&
        !value
      ) {
        callback(new Error(i18n.t("message.formRuleMessage.notNull")));
      }
      if (
        this.application.confirmEmail &&
        value !== this.application.confirmEmail
      ) {
        callback(
          new Error(i18n.t("message.formRuleMessage.taxi_email_confirm"))
        );
      } else {
        callback();
      }
    };
    let confirmEmailCheck = (rule, value, callback) => {
      if (
        this.application &&
        this.application.paymentType === "CEP" &&
        !value
      ) {
        callback(new Error(i18n.t("message.formRuleMessage.notNull")));
      }
      if (this.application.email && !value) {
        callback(new Error(i18n.t("message.formRuleMessage.taxi_email")));
      } else if (this.application.email && value !== this.application.email) {
        callback(
          new Error(i18n.t("message.formRuleMessage.taxi_email_confirm"))
        );
      } else {
        callback();
      }
    };
    return {
      loading: false,
      submitLoading: false,
      resourcePath: resourcePath,
      serviceType: this.$route.meta.type,
      vssData: {},
      application: {},
      ruleForm: {
        paymentType: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        email: [
          { validator: emailCheck, trigger: "blur" },
          {
            type: "email",
            message: i18n.t("message.formRuleMessage.email"),
            trigger: ["blur"],
          },
        ],
        confirmEmail: [
          { validator: confirmEmailCheck, trigger: "blur" },
          {
            type: "email",
            message: i18n.t("message.formRuleMessage.email"),
            trigger: ["blur"],
          },
        ],
      },
      payMethod: [],
      showRepeatDialog: false,
      timeParams: {},
    };
  },
  methods: {
    submit() {
      this.$refs["ruleForm"].validate(async (valid) => {
        try {
          if (valid) {
            const serviceType = this.serviceType;
            const { identType, identNo, licenseNo } =
              this.$store.state.verifyForm;
            let application = this.application;
            this.submitLoading = true;
            const res = await SchoolRenewApplicationAPI.submit(
              application.email,
              application.cert && application.cert.sendSms,
              serviceType,
              identType,
              identNo,
              licenseNo
            );
            this.vssData = res;
            this.pay();
            this.submitLoading = await false;
          } else {
            this.$message({
              type: "error",
              message: this.$t("message.form_error"),
            });
          }
        } catch (error) {
          this.submitLoading = false;
          this.$error(error);
        }
      });
    },
    async pay() {
      try {
        const serviceType = this.serviceType;
        const applicationNo =
          this.vssData.application && this.vssData.application.applicationNo;
        const channel = this.application.paymentType;
        const email = this.application.email;
        const basePath = this.resourcePath;
        let url = "";
        this.submitLoading = true;
        url = "/public/api/v1/school/start/pay";
        await SchoolRenewApplicationPublicAPI.frequency(applicationNo);
        this.submitLoading = await false;
        const fullUrl = `${basePath}${url}/${serviceType}?applicationNo=${applicationNo}&channel=${channel}${
          email ? `&email=${email}` : ""
        }`;
        if (this.$store.state.isApp) {
          this.$router.push({
            path: "/way",
            query: {
              url: fullUrl,
              applicationNo: applicationNo,
            },
          });
        } else {
          this.submitLoading = true;
          window.location.href = fullUrl;
        }
      } catch (err) {
        this.submitLoading = false;
        this.submitLoading = false;
        if (err.code == "REPEAT_PAYMENT_ERROR") {
          this.timeParams = {
            currentTime: this.$formatDate(
              new Date().toISOString(),
              "yyyy-MM-dd HH:mm:ss"
            ),
            formatCreateTime: err.message,
          };
          this.showRepeatDialog = true;
        } else {
          if (err.code == "PAYMENT_CHECK_FAIL") {
            const errMsg = JSON.parse(err.message);
            this.$message({
              type: "error",
              message:
                errMsg[
                  `failedMsg${
                    this.$i18n.locale == "ZH_TW" || this.$i18n.locale == "ZH_CN"
                      ? "Cn"
                      : "Pt"
                  }`
                ],
            });
          } else {
            this.$error(err);
          }
        }
      }
    },
    // 關閉重複支付提示彈窗
    handleClose() {
      this.showRepeatDialog = false;
    },
  },
  async created() {
    try {
      const serviceType = this.serviceType;
      const { identType, identNo, licenseNo } = this.$store.state.verifyForm;
      this.loading = true;
      // 獲取支付方式
      const payMethod = await ServiceTypeConfigAPI.getPayMethod(serviceType);
      this.payMethod = payMethod.map((ele) => {
        ele.icon = ele.paymentChannel.toLowerCase();
        ele.name = ele.paymentChannel;
        return ele;
      });
      // 准入
      let res = {};
      res = await SchoolRenewApplicationAPI.check(
        serviceType,
        identType,
        identNo,
        licenseNo
      );
      this.vssData = JSON.parse(JSON.stringify(res));
      if (res && res.application) {
        res.application.language = this.$t("message.lang");
        let cheque = res.application.cheque;
        if (cheque) {
          cheque.amount = formatAmount(cheque.amount);
          cheque.taxAmount = formatAmount(cheque.taxAmount);
          cheque.totalAmount = formatAmount(cheque.totalAmount);
        }
        this.application = res && res.application;
      }

      this.loading = await false;
    } catch (error) {
      this.loading = false;
      this.$error(error);
    }
  },
};
</script>

<style lang="scss" scoped>
.itnal_info_box {
  background: #fffcf0;
  border: 1px solid #f7b463;
  border-radius: 10px;
  margin: 24px auto;
  overflow: hidden;
  .el-row {
    align-items: flex-start;
    padding: 24px 4%;
  }
  .el-col {
    margin-bottom: 20px;
  }
  .infoTips {
    background: #e54b5d;
    color: #fff;
    font-size: 18px;
    padding: 10px;
    text-align: center;
  }
}
.itnal_info_label {
  color: #7f7f7f;
  font-size: 18px;
  margin-right: 12px;
}
.itnal_info_data {
  color: #333;
  font-size: 18px;
  flex: 1;
}
.itnal_info_question {
  background: #f2f2f2;
  color: #333;
  font-size: 16px;
  padding: 5px 10px;
  border-radius: 10px;
  clear: both;
}
.hide_formGroup_title {
  /deep/.formGroup_title {
    display: none;
  }
}
.payment_notice {
  max-width: 700px;
  margin: auto;
  padding: 30px;
  background: #fef9f3;
  border: 1px solid #facd91;
  border-radius: 5px;
}
.pn_title {
  color: #f59a23;
  font-size: 26px;
  margin-bottom: 20px;
}
.pn_list {
  /deep/.el-form {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  /deep/.el-form-item {
    margin-right: 20px;
  }
  /deep/.el-form-item.is-error .el-input__inner {
    box-shadow: 0 0 black;
  }
}
.pn_list li {
  margin-bottom: 12px;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.pn_list li span {
  display: inline-block;
  // min-width: 180px;
}
.pn_list li .el-input {
  flex: 1;
  margin-right: 20px;
}
/deep/.pn_list li .el-input input {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #333;
  background-color: transparent;
  text-align: center;
}

/deep/.el-radio {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/.el-radio + .el-radio {
  margin-top: 20px;
}
/deep/.el-radio__label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.mpay_icon {
  width: auto;
  height: 50px;
  display: block;
  margin-right: 10px;
}

@media screen and (max-width: 767px) {
  .payment_notice {
    margin-left: 15px;
    margin-right: 15px;
  }
  .pn_email_text {
    margin-bottom: 20px;
  }
  .pn_list li {
    flex-direction: column;
  }
}
</style>